import { LastMessageText } from '@halo/ui-chat-react';
import { Box, Text } from '@chakra-ui/react';
import { useMsgMediaTitle } from '../msg-media-call';
import type { MsgMediaCallNetworkErrorContentProps } from './msg-media-call-network-error-content';
import { MsgMediaCallNetworkErrorContent } from './msg-media-call-network-error-content';

export interface MsgMediaCallNetworkErrorPreviewProps
  extends MsgMediaCallNetworkErrorContentProps {}

export const MsgMediaCallNetworkErrorPreview = memo(function MsgMediaCallNetworkErrorPreview({
  message,
}: MsgMediaCallNetworkErrorPreviewProps) {
  const { type } = message.payload;

  const { title } = useMsgMediaTitle({ type });

  return (
    <LastMessageText>
      <Text as="span" color="fg.error" flexShrink={0}>
        {title}
      </Text>
      <Box as="span" truncate minW={0} flex={1}>
        <MsgMediaCallNetworkErrorContent message={message} />
      </Box>
    </LastMessageText>
  );
});
